import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatCardModule} from '@angular/material/card';

@Component({
  selector: 'app-generic-card',
  templateUrl: './generic-card.component.html',
  styleUrls: ['./generic-card.component.scss'],
  standalone: true,
  imports: [CommonModule, MatCardModule]
})
export class GenericCardComponent {
  @Input() title!: string;
  @Input() subtitle!: string;
}
